export default {"src":"/_next/static/media/unhappy_24.03f493b2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};